<script>
import Component from '~/sites/soh/pages/article/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/clanek/:slug',
      de: '/artikel/:slug',
      en: '/article/:slug',
      sk: '/clanok/:slug',
    },
  },
}
</script>
